import { h, Component } from 'preact'
import AlertComponent from '../ui-components/AlertComponent'
import axios from 'axios'
import Header from '../header'
import WarningBox from '../ui-components/WarningBox'

type Props = {}

type Features = {}

type State = {
  features: Features,
  showAlert: boolean,
  alertType: string|null,
  alertMessage: string|null,
  alertVisibleFor: number|null,
}

const titles = {}

class ExperimentalFeatures extends Component<{}, State> {
  constructor () {
    super()
    this.state = {
      features: {},
      showAlert: false,
      alertType: null,
      alertMessage: null,
      alertVisibleFor: null,
    }
  }

  async onToggleFeature (feature: keyof Features) {
    const { features } = this.state
    await axios.post('/experimentalFeatures/save', { module: feature, enable: !features[feature] })
      .then(() =>     this.setState({
        features: Object.assign(features, { [feature]: !features[feature] }),
        showAlert: true,
        alertType: 'success',
        alertMessage: `‘${titles[feature]}’ is updated successfully!`,
        alertVisibleFor: 3000
      }))
      .catch(() => this.setState({
        showAlert: true,
        alertType: 'error',
        alertMessage: null
      }))
  }

  render (_: Props, { features, showAlert, alertType, alertMessage, alertVisibleFor }: State) {
    return (
      <div class='experimental-features'>
        {showAlert && <AlertComponent
            messageType={alertType}
            message={alertMessage}
            isVisibleFor={alertVisibleFor}
            sticky
            onTimeoutEnd={() => this.setState({ showAlert: false })}
        />}
        <Header title='Experimental Features' disableSaveButton disableCancelButton />
        <WarningBox message="On this page, you can opt in and out of experimental features that we're testing on the inSided platform." />
      </div>
    )
  }
}

export default ExperimentalFeatures
